export default __webpack_public_path__ + "static/media/investing.2c4cfc20.svg";